import { Injectable } from '@angular/core';
import { AccessRightType, ActionType, ApplicationSettingsType, ObjectTypes } from '@fi-shared/types';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiNewsFeedPinSettingsDialogComponent } from '@fi-shared/fi-news-feed-shared/fi-news-feed-pin-settings-dialog/fi-news-feed-pin-settings-dialog.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiSnackBarService } from '@fi-shared/fi-snackbar/snack-bar.service';

@Injectable()
export class FiNewsFeedPinService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private snackBar: FiSnackBarService,
    ) {}

    canChangePin(objectType: number) {
        return (
            this.accessToApplicationTypeService.HasAccessToApplicationType(
                ApplicationSettingsType.PostCentral,
                AccessRightType.Admin,
            ) &&
            [ObjectTypes.Post, ObjectTypes.MediaBank, ObjectTypes.Document, ObjectTypes.MediaBankGrouped].includes(
                objectType,
            )
        );
    }

    openPinSettingsDialog(objectId: number, objectType: ObjectTypes, pinnedUntil: Date | string) {
        return new Promise<{ result: boolean; newPinnedUnitl?: Date }>((resolve, reject) => {
            this.fiDialogsService
                .custom({
                    headerText: this.appTextService.get('post.pin_post'),
                    yesButtonText: this.appTextService.get('post.pin_post'),
                    contentComponentRef: FiNewsFeedPinSettingsDialogComponent,
                    contentComponentData: pinnedUntil,
                    config: {
                        minWidth: 'unset',
                        width: '405px',
                    },
                })
                .onYesButtonClick((newPinnedUntil) => {
                    this.fiLoading
                        .trackPromise(
                            this.fiBackend.fetchDataPost('NewsFeed/NewsFeed/ChangePinSettings', {
                                ObjectId: objectId,
                                ObjectType: objectType,
                                Action: ActionType.Pinned,
                                PinnedUntil: newPinnedUntil,
                            }),
                        )
                        .then(() => {
                            this.snackBar.showSnackbar({
                                textMessage: this.appTextService.get('post.post_pinned'),
                                buttonText: this.appTextService.get('common.dismiss'),
                            });
                            resolve({
                                result: true,
                                newPinnedUnitl: newPinnedUntil,
                            });
                        }, reject);
                })
                .onNoButtonClick(() => resolve({ result: false }));
        });
    }

    removePin(objectId: number, objectType: ObjectTypes) {
        return this.fiLoading
            .trackPromise(
                this.fiBackend.fetchDataPost('NewsFeed/NewsFeed/ChangePinSettings', {
                    ObjectId: objectId,
                    ObjectType: objectType,
                    Action: ActionType.RemovedPin,
                }),
            )
            .then(() => {
                this.snackBar.showSnackbar({
                    textMessage: this.appTextService.get('post.pin_removed'),
                    buttonText: this.appTextService.get('common.dismiss'),
                });
            });
    }
}
